import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SupplierDataCheckAction } from "../../../../../libs/coreapi-dto/dirs/supplierDataCheck";
import { IErrorItem } from "../../../../../components/alert/alertHelpers";

interface IValidationCallbacks {
    onCancel: () => void;
    onConfirm?: () => void;
}

interface IModalConfig {
    visible: boolean;
    header: string;
    warning: string;
    items: IErrorItem[];
    question: string;
    action: SupplierDataCheckAction;
    onConfirm?: () => void;
    onCancel: () => void;
    largeTextArea?: boolean;
    textAreaInputStyle?: React.CSSProperties;
}

export const useAlertsModal = () => {
    const [modalConfig, setModalConfig] = useState<IModalConfig | null>(null);

    const closeModal = () => {
        setModalConfig(null);
    };
    const { t } = useTranslation();

    const constructorAlertModal = (
        items: IErrorItem[],
        action: SupplierDataCheckAction,
        callbacks?: IValidationCallbacks
    ) => {
        if (items.length === 0) {
            callbacks?.onConfirm?.();
            return;
        }
        
        const baseModalConfig = {
            visible: true,
            header: t('documents.invoice.messages.alertsModalTitle'),
            warning: '',
            items: items,
            onCancel: () => {
                closeModal();
                callbacks?.onCancel();
            },
            largeTextArea: true,
        }

        if (items.length && items.length > 0) {

            if (action === "LOCK" && items.some(item => item.alerts.some(alert => alert.field.includes("producerPrice")))) {
                setModalConfig({
                    ...baseModalConfig,
                    question: t('documents.invoice.messages.noSave'),
                    action: "LOCK",
                    textAreaInputStyle: { backgroundColor: "rgb(204, 51, 51, 0.2)", color: "black" }
                });
            } else {
                setModalConfig({
                    ...baseModalConfig,
                    question: t('documents.invoice.messages.continue'),
                    action: "WARN",
                    onConfirm: () => {
                        closeModal();
                        callbacks?.onConfirm?.();
                    },
                    textAreaInputStyle: { backgroundColor: "rgb(255, 204, 51, 0.2)", color: "black" }
                });
            }
        }
    };

    return {
        constructorAlertModal,
        modalConfig,
        closeModal
    };
}
